// A hung request (flaky cellular, a dropped connection) never rejects on its own —
// fetch/Supabase have no built-in timeout, so a component awaiting one just sits in
// its loading state forever with no error to catch and nothing to show the user
// (reported live, 2026-08-27: Notifications stuck on its skeleton on a 2-bar
// connection). Race the real work against a timer so a hang becomes a normal,
// recoverable error instead of an infinite spinner.
export function withTimeout(promise, ms, label = 'request') {
  return Promise.race([
    promise,
    new Promise((_, reject) => setTimeout(() => reject(new Error(`${label} timed out after ${ms}ms`)), ms)),
  ])
}
